import { render, staticRenderFns } from "./IntentoDashboard.vue?vue&type=template&id=ea704fe0&scoped=true&"
import script from "./IntentoDashboard.vue?vue&type=script&lang=js&"
export * from "./IntentoDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea704fe0",
  null
  
)

export default component.exports